export const ROUTES = {
  mainScreen: "/",
  matchesScreen: "/matches",
  kitsScreen: "/kits",
  sponsorsScreen: "/sponsors",
  teamsScreen: "/teams",

  //User routes
  loginScreen: "/login",
  userScreen: "/user",
  manageScreen: "/manageteam",
  myTeam: "/myteam",

  //user internal
  userInfo: "/user",
  userRatings: "/user/ratings",
  userMatches: "/user/matches",
  userAttendance: "/user/attendance",
  userContributions: "/user/contributions",

  //team internal
  teamCard: "/myteam",
  changeTeamCard: "/myteam/changeteam",
  ratePlayer: "/myteam/rateplayer",

  //manage internal
  collectMoney: "/manageteam",
  attendance: "/manageteam/attendance",
  players: "/manageteam/players",
  addPlayer: "/manageteam/addplayer",
  newPlayerRequests: "/manageteam/newplayers",
  addGoalsAndAssists: "/manageteam/goalsandassists",
};
